import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { apolloClient } from '~/javascripts/lib/graphql';
import convertObjectPropsToCamelCase from '~/javascripts/lib/convert_object_props_to_camel_case';
import NewGitlabSubscriptionApp from '~/javascripts/subscription/components/new_gitlab_subscription.vue';
import parseBoolean from '~/javascripts/lib/parse_boolean';
import tryJSONParse from '~/javascripts/lib/try_json_parse';

Vue.use(VueApollo);

const apolloProvider = new VueApollo({ defaultClient: apolloClient });
const initGitlabSubscriptionApp = () => {
  const containerElement = document.querySelector('#js-new-gitlab-com-subscription');
  if (!containerElement) {
    return false;
  }

  const {
    currentNamespaceId,
    successRedirectPath,
    customer: userRaw,
    seatPrice: seatPriceRaw,
    namespaces: namespacesJson,
    planId,
    planName,
    planCode,
    zuoraAccountNumber,
    promoCode,
  } = containerElement.dataset;

  const seatPrice = Number(seatPriceRaw);

  const namespaces = convertObjectPropsToCamelCase(JSON.parse(namespacesJson), { deep: true });

  const eligibleToUsePromoCode = parseBoolean(containerElement.dataset.eligibleToUsePromoCode);

  const user = convertObjectPropsToCamelCase(tryJSONParse(userRaw, {}));

  const customerBillingAccountsPresent = parseBoolean(
    containerElement.dataset.customerBillingAccountsPresent,
  );

  return new Vue({
    el: containerElement,
    provide: {
      customerBillingAccountsPresent,
      zuoraAccountNumber,
      planCode,
      eligibleToUsePromoCode,
      promoCode,
    },
    render(createElement) {
      return createElement(NewGitlabSubscriptionApp, {
        props: {
          successRedirectPath,
          namespaces,
          currentNamespaceId: parseInt(currentNamespaceId, 10),
          user,
          seatPrice,
          planId,
          planName,
        },
      });
    },
    apolloProvider,
  });
};

export default initGitlabSubscriptionApp;
